import { getAdminApprovalGroups } from '@lib/api'
import { adminApprovalGroupsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useAdminApprovalGroups = () => {
  return useQuery(adminApprovalGroupsKeys.all, () => getAdminApprovalGroups())
}
